import create from "zustand";
import {devtools} from "zustand/middleware";

let taskStore = (set) => ({
  tasks: [],
  taskCounts: {
    resolvedTaskCount: 0
  },
  setTasks: (tasks) => set(state => ({tasks})),
  updateTask: (taskId, task) => set(
    (state) => {
      const {tasks} = state;
      let updatedTask;
      let index = tasks.findIndex(item => item.id === taskId);
      if (index >= 0) {
        updatedTask = {
          ...tasks[index],
          ...task
        }
      } else {
        index = tasks.length;
        updatedTask = task;
      }
      tasks[index] = updatedTask;
      return {
        tasks: [...tasks]
      };
    }
  ),
  removeTask: (id) => set(
    state => {
      return {
        tasks: state.tasks.filter(task => task.id !== id)
      }
    }
  ),
  setTaskCounts: (taskCounts) => set((state) => ({taskCounts}))
});

taskStore = devtools(taskStore);

const useTaskStore = create(taskStore);

export default useTaskStore;


// WEBPACK FOOTER //
// ./src/stores/TaskStore.js